<template>
  <div :class="$style.root">
    <i18nLink
      v-if="attributes?.slug"
      :to="{ name: 'journals-slug', params: { slug: attributes?.slug } }"
      :locale="i18nCode"
      :class="$style.link"
    >
      <LayoutImageWithCaptionComponent>
        <template #image>
          <CoreImageComponent
            v-if="attributes?.coverImage?.data?.attributes"
            :image="attributes?.coverImage?.data?.attributes"
            :class="$style.coverImage"
            :showCaption="false"
            :data-orientation="getOrientation(attributes?.coverImage?.data?.attributes)"
          />
          <div
            v-if="firstParagraph && !attributes?.coverImage?.data?.attributes"
            :class="$style.firstParagraph"
          >
            <CoreTextComponent :string="firstParagraph" />
          </div>
        </template>

        <template #caption>
          <div>
            <span :class="$style.type">{{ $t('pages.journals.label')?.toLowerCase() }}</span> <span :class="$style.title">{{ title }}</span>
          </div>
          <div
            v-if="attributes?.datePosted"
            :class="$style.updatedAt"
          >
            {{ $t('shared.datePosted') }}:
            <CoreDateTimeRangeComponent
              :dateStart="attributes?.datePosted"
              format="D MMMM YYYY"
            />
          </div>
        </template>
      </LayoutImageWithCaptionComponent>
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    data: Object
  })

  const localizedData = baseStrapiGetLocalizedData(props.data)

  const attributes = baseStrapiGetAttributes(localizedData)
  const i18nCode = baseI18nGetCodeForIso(attributes?.locale)
  const truncate = (str: string, length: number = 60) => {
    return str?.length > length ? str?.substring(0, length - 3) + '...' : str
  }
  const firstParagraph = truncate(baseStrapiGetFirstParagraphFromBlocks(attributes?.blocks))

  const tags = attributes?.journalTags?.data?.map(i => i?.attributes?.label)?.filter(Boolean)

  // NOTE extract to base, make part of component, also add square
  const getOrientation = (image) => {
    if (image?.width && image?.height) {
      return image.width > image.height ? 'landscape' : 'portrait'
    }
  }

  const title = baseTruncateString(attributes?.title, 14)

</script>

<style module>
  .root {
  }

  .link {
    composes: reset-link from global;
  }

  .heading {
  }

  .title {
    composes: font-helvetica font-size-small from global;
    text-decoration-line: underline;
  }


  .link:hover .title {
    text-decoration-line: none;
  }

  .type {
    composes: font-size-small font-helvetica label-inverted from global;
  }

  .coverImage {
    --base--image--object-fit: contain;
    --base--image--object-position: center;

    display: flex;
    justify-content: center;
  }

  .coverImage img {
  }

  .coverImage[data-orientation='portrait'] {
    --base--image--object-fit: cover;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  .firstParagraph {
    composes: font-default font-size-x-large from global;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 3 / 2;

    background-color: var(--color--pink);
    overflow: hidden;

    padding: var(--padding--element);
  }

  .updatedAt {
    composes: font-helvetica font-size-small from global;
  }
</style>
